import { createClient } from 'next-sanity';

/** Importing an unused legacy reader must not require a configured Sanity service. */
export function lazySanityClient(): ReturnType<typeof createClient> {
  let client: ReturnType<typeof createClient> | undefined;
  const configured = () => {
    if (client) return client;
    const dataset = process.env.SANITY_STUDIO_DATASET;
    const projectId = process.env.SANITY_STUDIO_PROJECT_ID;
    if (!dataset) throw new Error('Missing environment variable: SANITY_STUDIO_DATASET');
    if (!projectId) throw new Error('Missing environment variable: SANITY_STUDIO_PROJECT_ID');
    client = createClient({
      dataset,
      projectId,
      apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-04-04',
      useCdn: false,
    });
    return client;
  };
  return new Proxy({} as ReturnType<typeof createClient>, {
    has(_target, field) {
      return Reflect.has(configured(), field);
    },
    get(_target, field) {
      if (field === 'then') return undefined;
      const instance = configured();
      const value = Reflect.get(instance, field, instance);
      return typeof value === 'function' ? value.bind(instance) : value;
    },
  });
}
